module.exports = __webpack_public_path__ + "img/tourist-information_odd.3ca0f11b.svg";